/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import ColorGradient from 'javascript-color-gradient';

import injectSheet from 'react-jss';
import { Modal, Box } from '@mui/material';
import { CSVLink, CSVDownload } from 'react-csv';

import Tippy from '@tippyjs/react';
import '../../../tippy.js/dist/tippy.css';

/* Qlik */
import useQlikApp from 'hooks/useQlikApp';
import useQlikSessionObject from 'hooks/useQlikSessionObject';
// import AppContext from '../../AppContext';

import GroupStyles from './Group_Styles';

import { getTeams } from '../../../redux/features/teams/teams';
import { getPicks } from '../../../redux/features/picks/picks';
import { setPick } from '../../../redux/features/picks/picksSlice';

const gradientParams = ['#FF0000', '#FFC0CB', '#dedede', '#90EE90', '#228B22'];

const styles = GroupStyles;

const Group = ({
  classes, name, teamz, pickz, group,
}) => {
  const dispatch = useDispatch();

  const teams = useSelector((state) => getTeams(state, teamz));
  const picks = useSelector((state) => getPicks(state, pickz));

  const qlikApp = useQlikApp();
  // const qlikApp = useContext(AppContext);

  const [isOpen, setIsOpen] = useState(false);

  // Qlik
  const qPredictions = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qInfo: { qType: 'dataMatchups' },
      qHyperCubeDef: {
        qDimensions: [{
          qDef: {
            qFieldDefs: ['grousp_predictions_team1'],
            qSortCriterias: [
              {
                qSortByAscii: 1,
              },
            ],
          },
          qNullSuppression: false,
        }, {
          qDef: {
            qFieldDefs: ['grousp_predictions_team2'],
            qSortCriterias: [
              {
                qSortByAscii: 1,
              },
            ],
          },
          qNullSuppression: false,
        }, {
          qDef: {
            qFieldDefs: ['grousp_predictions_winPrediction'],
            qSortCriterias: [
              {
                qSortByAscii: 1,
              },
            ],
          },
          qNullSuppression: false,
        }],
        qMeasures: [
          {
            qDef: {
              qDef: `Only({<grousp_predictions_group={'${group}'}>} grousp_predictions_winPredictionNum)`,
            },
          },
        ],
        qInitialDataFetch: [{
          qWidth: 4,
          qHeight: 2500,
        }],
      },
    },
  });

  const dataGroupPrediction = useMemo(() => {
    if (!qPredictions.layout || !isOpen) return [];
    let qlikDataGroupPrediction = [];
    if (qPredictions.layout.qHyperCube.qError) {
      qlikDataGroupPrediction = [];
    } else {
    // eslint-disable-next-line prefer-destructuring
      qlikDataGroupPrediction = qPredictions.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => ({
        team1: row[0].qText,
        team2: row[1].qText,
        winPrediction: row[2].qText,
        winPredictionNum: row[2].qNum,
      }));
    }
    return qlikDataGroupPrediction;
  }, [qPredictions.layout, isOpen]);

  // Filter Team 1 Group
  const qFilterTeam1Group = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qListObjectDef: {
        qDef: {
          qFieldDefs: ['Team1Group'],
        },
        qInitialDataFetch: [{ qWidth: 1, qHeight: 35 }],
        qShowAlternatives: true,
      },
    },
  });

  // Filter Team 2 Group
  const qFilterTeam2Group = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qListObjectDef: {
        qDef: {
          qFieldDefs: ['Team2Group'],
        },
        qInitialDataFetch: [{ qWidth: 1, qHeight: 35 }],
        qShowAlternatives: true,
      },
    },
  });

  const handleOpen = () => {
    if (!qFilterTeam1Group.model || !qFilterTeam2Group.model) {
      return;
    }
    // Get qElemNumber of Group
    const qElem = qFilterTeam1Group.layout.qListObject.qDataPages[0].qMatrix.filter((row) => row[0].qText === group);
    // Make selections
    qFilterTeam1Group.model.selectListObjectValues('/qListObjectDef', [qElem[0][0].qElemNumber], true);
    qFilterTeam2Group.model.selectListObjectValues('/qListObjectDef', [qElem[0][0].qElemNumber], true);
    setIsOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    qlikApp.clearAll();
    setIsOpen(false);
  };

  const handlePick = (_picks, teamId) => {
    const prev = _picks.find((pick) => pick.teamId === teamId);
    if (prev) {
      dispatch(setPick({ ...prev, teamId: null }));
      return;
    }
    const next = _picks.find((pick) => pick.teamId === null);
    if (next) {
      dispatch(setPick({ ...next, teamId }));
    }
  };

  const colorCellFromValue = (params, value, midpoint = 10) => {
    const getColorIndex = Math.round(midpoint * value);
    const color = new ColorGradient()
      .setColorGradient(...params)
      .setMidpoint(midpoint)
      .getColor(getColorIndex === 0 ? 0.01 : getColorIndex);
    return color;
  };

  return (
    <div className={classes.group}>
      <div className={classes.groupnamerow} onClick={handleOpen}>
        <span className={classes.groupname}>
          {name}
        </span>
        <span className={classes.groupinfo}>
          i
        </span>
      </div>
      {
          teams.map((team) => (
            <div
              key={team.id}
              className={(() => {
                switch (picks.findIndex((pick) => pick.teamId === team.id)) {
                  case 0: return classes.row_firstpicked;
                  case 1: return classes.row_secondpicked;
                  default: return classes.row;
                }
              })()}
              style={{
                opacity: (() => {
                  if (picks[0].teamId === team.id) return '1';
                  if (picks[1].teamId === team.id) return '1';
                  if (picks[0].teamId && picks[1].teamId) return '0.4';
                  return '1';
                })(),
              }}
            >
              <div
                className={(() => {
                  switch (picks.findIndex((pick) => pick.teamId === team.id)) {
                    case 0: return classes.firstpicked;
                    case 1: return classes.secondpicked;
                    default: return classes.nopicked;
                  }
                })()}
                onClick={() => handlePick(picks, team.id)}
              >
                {
                  picks.findIndex((pick) => pick.teamId === team.id) + 1
                    ? (
                      <div className={classes.picked} style={{ backgroundColor: picks.findIndex((pick) => pick.teamId === team.id) === 0 ? '#62AD1D' : '#F9981D' }}>
                        {picks.findIndex((pick) => pick.teamId === team.id) + 1}
                      </div>
                    ) : (
                      <div
                        className={classes.nonpick}
                        style={{
                          background: (() => {
                            if (picks[0].teamId === team.id) return 'inherit';
                            if (picks[1].teamId === team.id) return 'inherit';
                            return `url(assets/images/flags/${team.id}.svg)`;
                          })(),
                        }}
                      />
                    )
                }

                <div className={classes.teamname}>
                  <div>
                    {team.name}
                  </div>
                </div>
              </div>

            </div>
          ))
        }
      {/* MODAL */}

      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="Group Information"
        aria-describedby="Group Information"
        BackdropProps={{
          style: { backgroundColor: 'rgba(0,0,0,0.85)' },
        }}
      >
        <Box className={classes.modalContainer}>
          <div className={classes.luidialogbody}>
            <div className={classes.closerow}>
              <span className={classes.close} onClick={() => handleClose()}>
                <img className={classes.img_close} src="assets/images/close.svg" alt="close" />
              </span>
            </div>
            <div className={classes.dialog}>
              <div className={classes.dialogbody}>
                <div className={classes.dialoggroupname}>
                  {name}
                </div>
                <div className={classes.dialoggroupdesc}>
                  Learn more about the teams in this group and their likelihood to advance.
                  Two teams must be selected to advance to the next stage.
                </div>
                <div className={classes.dialoggroups}>
                  {teams.map((team) => (
                    <div
                      key={team.id}
                      className={classes.dialoggroup}
                      style={{
                        opacity: (() => {
                          if (picks[0].teamId === team.id) return '1';
                          if (picks[1].teamId === team.id) return '1';
                          if (picks[0].teamId && picks[1].teamId) return '0.4';
                          return '1';
                        })(),
                      }}
                    >
                      <div className={classes.flag} onClick={() => handlePick(picks, team.id)}>
                        <img
                          src={`assets/images/flags/${team.id}.svg`}
                          className={classes.flagImg}
                          alt={team.name}
                        />
                      </div>
                      <div
                        className={classes.dialogteamname}
                        style={{
                          color: (() => {
                            if (picks[0].teamId === team.id) return '#62AD1D';
                            if (picks[1].teamId === team.id) return '#F9981D';
                            if (picks[0].teamId && picks[1].teamId) return '#ccc';
                            return '#666';
                          })(),
                        }}
                        onClick={() => handlePick(picks, team.id)}
                      >
                        {team.name}
                      </div>
                      <div className={classes.rank}>
                        <b>FIFA RANK:</b>
                        {' '}
                        {team.fifarank}
                      </div>
                      <div className={classes.rank}>
                        <b>ELO RANK:</b>
                        {' '}
                        {team.elorank}
                      </div>
                    </div>
                  ))}

                </div>

                {!!dataGroupPrediction.length && (
                <div className={classes.tablePredictionGroup}>
                  <div className={classes.tablePredictionGroupHeading}>Group Matchup Predictions</div>

                  <table className={classes.tableGroup}>
                    <thead>
                      <tr>
                        <th className={classes.thTeamEmpty}>&nbsp;</th>
                        <th className={classes.thTeam}>{dataGroupPrediction[0].team2}</th>
                        <th className={classes.thTeam}>{dataGroupPrediction[1].team2}</th>
                        <th className={classes.thTeam}>{dataGroupPrediction[2].team2}</th>
                        <th className={classes.thTeam}>{dataGroupPrediction[3].team2}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* First Row - Ecuador */}
                      <tr>
                        <td className={classes.tdTeam}>{dataGroupPrediction[0].team1}</td>
                        <td className={classes.tdCellEmpty}>&nbsp;</td>
                        {/* ecuador vs netherlands */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[1].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[1].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[1].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[4].winPrediction.split('%')[0] - dataGroupPrediction[1].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[4].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[1].winPredictionNum),
                            }}
                          >
                            {dataGroupPrediction[1].winPrediction}
                          </td>
                        </Tippy>
                        {/* Ecuador vs Qatar */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[2].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[2].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[2].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[8].winPrediction.split('%')[0] - dataGroupPrediction[2].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[8].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[2].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[2].winPrediction}
                          </td>
                        </Tippy>
                        {/* Ecuador vs Senegal */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[3].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[3].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[3].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[12].winPrediction.split('%')[0] - dataGroupPrediction[3].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[12].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[3].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[3].winPrediction}
                          </td>
                        </Tippy>
                      </tr>
                      {/* 2nd Row - Netherlands */}
                      <tr>
                        <td className={classes.tdTeam}>{dataGroupPrediction[4].team1}</td>
                        {/* Netherlands vs Ecuador */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[4].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[4].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[4].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[4].winPrediction.split('%')[0] - dataGroupPrediction[1].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[1].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[4].winPredictionNum),

                            }}

                          >
                            {dataGroupPrediction[4].winPrediction}
                          </td>
                        </Tippy>
                        <td className={classes.tdCellEmpty}>&nbsp;</td>
                        {/* Netherlands vs Qatar */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[6].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[6].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[6].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[6].winPrediction.split('%')[0] - dataGroupPrediction[9].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[9].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[6].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[6].winPrediction}
                          </td>
                        </Tippy>
                        {/* Netherlands vs Senegal */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[7].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[7].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[7].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[13].winPrediction.split('%')[0] - dataGroupPrediction[7].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[13].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[7].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[7].winPrediction}
                          </td>
                        </Tippy>
                      </tr>
                      {/* Row 3 - Qatar */}
                      <tr>
                        <td className={classes.tdTeam}>{dataGroupPrediction[8].team1}</td>
                        {/* Qatar vs Ecuador */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[8].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[8].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[8].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[8].winPrediction.split('%')[0] - dataGroupPrediction[2].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[2].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[8].winPredictionNum),
                            }}
                          >
                            { dataGroupPrediction[8].winPrediction}
                          </td>
                        </Tippy>
                        {/* Qatar vs Netherlands */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[9].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[9].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[9].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[9].winPrediction.split('%')[0] - dataGroupPrediction[6].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[6].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[9].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[9].winPrediction}
                          </td>
                        </Tippy>
                        <td className={classes.tdCellEmpty}>&nbsp;</td>
                        {/* Qatar vs Senegal */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[11].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[11].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[11].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[11].winPrediction.split('%')[0] - dataGroupPrediction[14].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[14].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[11].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[11].winPrediction}
                          </td>
                        </Tippy>
                      </tr>
                      {/* Row 4 - Senegal */}
                      <tr>
                        <td className={classes.tdTeam}>{dataGroupPrediction[12].team1}</td>
                        {/* Senegal vs Ecuador */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[12].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[12].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[12].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[12].winPrediction.split('%')[0] - dataGroupPrediction[3].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[3].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[12].winPredictionNum),
                            }}
                          >
                            {dataGroupPrediction[12].winPrediction}
                          </td>
                        </Tippy>
                        {/* Senegal vs Netherlands */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[13].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[13].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[13].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[13].winPrediction.split('%')[0] - dataGroupPrediction[7].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[7].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[13].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[13].winPrediction}
                          </td>
                        </Tippy>
                        {/* Senegal vs Qatar */}
                        <Tippy content={(
                          <div style={{ padding: '5px' }}>
                            <div>
                              {dataGroupPrediction[14].team1}
                              {' '}
                              vs
                              {' '}
                              {dataGroupPrediction[14].team2}
                            </div>
                            <div>
                              Win:
                              {' '}
                              {dataGroupPrediction[14].winPrediction}
                            </div>
                            <div>
                              Draw:
                              {' '}
                              {`${(100 - dataGroupPrediction[14].winPrediction.split('%')[0] - dataGroupPrediction[11].winPrediction.split('%')[0]).toFixed(1)}%`}
                            </div>
                            <div>
                              Loss:
                              {' '}
                              {dataGroupPrediction[11].winPrediction}
                            </div>
                          </div>
                        )}
                        >
                          <td
                            className={classes.tdCell}
                            style={{
                              backgroundColor: colorCellFromValue(gradientParams, dataGroupPrediction[14].winPredictionNum),
                            }}

                          >
                            {dataGroupPrediction[14].winPrediction}
                          </td>
                        </Tippy>
                        <td className={classes.tdCellEmpty}>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className={classes.ourGroupPred}>
                    We Predict that
                    {' '}
                    { group === 'A' && 'Netherlands' }
                    { group === 'B' && 'England' }
                    { group === 'C' && 'Argentina' }
                    { group === 'D' && 'Denmark' }
                    { group === 'E' && 'Germany' }
                    { group === 'F' && 'Belgium' }
                    { group === 'G' && 'Brazil' }
                    { group === 'H' && 'Uruguay' }
                    {' '}
                    and
                    {' '}
                    { group === 'A' && 'Ecuador' }
                    { group === 'B' && 'the USA' }
                    { group === 'C' && 'Mexico' }
                    { group === 'D' && 'France' }
                    { group === 'E' && 'Spain' }
                    { group === 'F' && 'Croatia' }
                    { group === 'G' && 'Switzerland' }
                    { group === 'H' && 'Portugal' }
                    {' '}
                    will advance to the knockout stage.
                  </div>
                </div>
                )}
              </div>
            </div>
          </div>
          <div className={classes.footerintro}>
            <div className={classes.footerdesc}>
              Select your favorite team in the group to advance first and then choose the second team to advance.
            </div>
          </div>
          <div className={classes.footer}>
            {teams.map((team) => (
              <div
                key={team.id}
                className={(() => {
                  switch (picks.findIndex((pick) => pick.teamId === team.id)) {
                    case 0: return classes.dialogbutton_firstpicked;
                    case 1: return classes.dialogbutton_secondpicked;
                    default: return classes.dialogbutton;
                  }
                })()}
                style={{
                  opacity: (() => {
                    if (picks[0].teamId === team.id) return '1';
                    if (picks[1].teamId === team.id) return '1';
                    if (picks[0].teamId && picks[1].teamId) return '0.4';
                    return '1';
                  })(),
                }}
              >

                <div
                  className={(() => {
                    switch (picks.findIndex((pick) => pick.teamId === team.id)) {
                      case 0: return classes.firstpicked;
                      case 1: return classes.secondpicked;
                      default: return classes.nopicked;
                    }
                  })()}
                  onClick={() => handlePick(picks, team.id)}
                >
                  {picks.findIndex((pick) => pick.teamId === team.id) + 1
                    ? (
                      <div className={classes.picked} style={{ backgroundColor: picks.findIndex((pick) => pick.teamId === team.id) === 0 ? '#62AD1D' : '#F9981D' }}>
                        {picks.findIndex((pick) => pick.teamId === team.id) + 1}
                      </div>
                    )
                    : <div className={classes.nonpick} />}
                  <div className={classes.teamname}>
                    {team.name === 'Korea Republic' && 'Korea R.'}
                    {team.name !== 'Korea Republic' && team.name}
                  </div>
                </div>

              </div>
            ))}
          </div>
        </Box>
      </Modal>
    </div>
  );
};

Group.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  group: PropTypes.string.isRequired,
  teamz: PropTypes.array.isRequired,
  pickz: PropTypes.array.isRequired,
};

export default injectSheet(styles)(Group);

// const att = [{ team1: 'Ecuador', team2: 'Ecuador', winPrediction: undefined },
//   { team1: 'Ecuador', team2: 'Netherlands', winPrediction: '0.1247163777377' },
//   { team1: 'Ecuador', team2: 'Qatar', winPrediction: '0.58316946522232' },
//   { team1: 'Ecuador', team2: 'Senegal', winPrediction: '0.34972480085476' },
//   { team1: 'Netherlands', team2: 'Ecuador', winPrediction: '0.69435893995856' },
//   { team1: 'Netherlands', team2: 'Netherlands', winPrediction: undefined },
//   { team1: 'Netherlands', team2: 'Qatar', winPrediction: '0.7379073148055' },
//   { team1: 'Netherlands', team2: 'Senegal', winPrediction: '0.70979102119179' },
//   { team1: 'Qatar', team2: 'Ecuador', winPrediction: '0.17593404272773' },
//   { team1: 'Qatar', team2: 'Netherlands', winPrediction: '0.022059135990646' },
//   { team1: 'Qatar', team2: 'Qatar', winPrediction: undefined },
//   { team1: 'Qatar', team2: 'Senegal', winPrediction: '0.19449453505124' },
//   { team1: 'Senegal', team2: 'Ecuador', winPrediction: '0.3078660140243' },
//   { team1: 'Senegal', team2: 'Netherlands', winPrediction: '0.11223521007144' },
//   { team1: 'Senegal', team2: 'Qatar', winPrediction: '0.54532188001529' },
//   { team1: 'Senegal', team2: 'Senegal', winPrediction: undefined }];
